import { LayerTypePrintableProps } from "react-migration/layouts/map/Multilayer/types";
import { Loading } from "./OutputAreaDetailView/OutputAreaDetailView";
import { SelectionType } from "src/js/stores/map/store";
import { SiteReportDemographicsWrapper } from "./SiteReportDemographicsWrapper";
import { useEffect } from "react";
import { useSiteReportConfiguration } from "react-migration/layouts/SiteReport/useSiteReportConfiguration/useSiteReportConfiguration";
import { useSiteReportDemographicsContext } from "./DemographicsProvider";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export function DemographicsPrintable({ selection, onLoaded, onUnmount }: LayerTypePrintableProps) {
  const { t } = useTranslation();

  const {
    targetDesignation,
    region: detectedRegion,
    attributeComparisonSpec: detectedAttributeComparisonSpec,
    loading,
  } = useSiteReportDemographicsContext();

  const [config] = useSiteReportConfiguration(selection.id ?? "");
  const savedComparisonRegionId = config.demographicsComparisonRegionId;

  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [loading, onLoaded]);

  useEffect(() => {
    return () => {
      onUnmount();
    };
  }, [onUnmount]);

  if (loading) {
    return (
      <div data-testid="demographics-printable-loading" className="mb-4">
        <h3>{t("sites.card.site_report.demographics")}</h3>
        <Loading />
      </div>
    );
  }

  if (!targetDesignation) {
    return (
      <div data-testid="demographics-printable-error" className="mb-4">
        <h3>{t("sites.card.site_report.demographics")}</h3>
        <p>
          {selection.type === SelectionType.SITE || selection.type === SelectionType.SHARED_SITE
            ? "No demographic data could be found for the selected site's location."
            : "No demographic data could be found for the current selection."}
        </p>
      </div>
    );
  }

  if (!detectedAttributeComparisonSpec || !detectedRegion) {
    return (
      <div data-testid="demographics-printable-error" className="mb-4">
        <h3>{t("sites.card.site_report.demographics")}</h3>
        <p>{"Could not determine demographic region or comparison specification for the selected area."}</p>
      </div>
    );
  }

  return (
    <div data-testid="demographics-printable" className="mb-4 demographics-printable print:break-before-page">
      <h3>{t("sites.card.site_report.demographics")}</h3>
      <SiteReportDemographicsWrapper selection={selection} printable initialComparableId={savedComparisonRegionId} />
    </div>
  );
}
